export default {
  SET_RECONNECTING(state, reconnecting) {
    state.reconnecting = reconnecting;
  },
  SET_ROOM(state, room) {
    state.room = room;
  },
  SET_AUDIO_TRACK(state, audioTrack) {
    state.audioTrack = audioTrack;
  },
};



// WEBPACK FOOTER //
// ./src/store/manual_calls/mutations.js